module.exports = __webpack_public_path__ + "static/media/plan_complexity_question.c1d82e0b.png";